import { ref, listAll, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../firebase";

/**
 * Fetches the category folders under "admin/training_files/" from Firebase Storage,
 * along with the files inside each category folder.
 * Returns an array of folder objects with folderId, folderName, fullName, and files array.
 */
export async function fetchCategoryFolders(departmentId) {
  try {
    console.log("");
    const rootPath = `admin/training_files/${departmentId}`;
    const rootRef = ref(storage, rootPath);
    const listResult = await listAll(rootRef);

    const folders = await Promise.all(
      listResult.prefixes.map(async (folderRef) => {
        const folderId = folderRef.name;
        const folderName = folderRef.name;
        const fullName = "Unknown User";

        // List files inside this folder
        const filesListResult = await listAll(folderRef);
        const files = await Promise.all(
          filesListResult.items.map(async (fileRef) => {
            const fileName = fileRef.name;
            const storagePath = fileRef.fullPath;
            let downloadURL = "";
            try {
              downloadURL = await getDownloadURL(fileRef);
            } catch (err) {
              console.warn("Failed to get download URL for", fileName, err);
            }
            return {
              fileName,
              storagePath,
              downloadURL,
            };
          })
        );

        return {
          folderId,
          folderName,
          fullName,
          files,
        };
      })
    );

    return folders;
  } catch (error) {
    console.error("Error fetching category folders:", error);
    return [];
  }
}
